module.exports = __webpack_public_path__ + "static/media/github.dd24e5cb.png";